/* NEX best sellers row on collection pages: Shopify's own best-selling ranking, loaded when the shopper scrolls near it */
(function () {
  'use strict';
  var m = document.querySelector('[data-best]');
  if (!m) return;
  var h = m.getAttribute('data-handle');
  function load() {
    fetch('/collections/' + h + '?sort_by=best-selling&section_id=best-sellers').then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var cards = [].slice.call(d.querySelectorAll('.card')).slice(0, 4);
      if (!cards.length) return;
      var t = document.createElement('h2'); t.className = 'recs__title'; t.textContent = 'Best sellers';
      var g = document.createElement('div'); g.className = 'recs__grid';
      cards.forEach(function (c) { c.classList.add('is-in'); g.appendChild(c); });
      m.appendChild(t); m.appendChild(g);
    }).catch(function () {});
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '300px' });
    io.observe(m);
  } else load();
})();
